export default "__VITE_ASSET__B4mTeu2e__"